/**
 * Hold until work finishes and a minimum elapsed time has passed.
 *
 * Belongs here: success-path loading floors (hub submit, risk profile).
 * Does not belong here: retries or toast.
 */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms)
  })
}

/**
 * Run `work`; on success wait until `minMs` from start. On error, optionally skip the floor.
 */
export async function awaitWithMinDuration<T>(
  work: () => Promise<T>,
  minMs: number,
  options?: { skipMinOnError?: boolean }
): Promise<T> {
  const startedAt = Date.now()
  try {
    const result = await work()
    const remaining = Math.max(0, minMs - (Date.now() - startedAt))
    if (remaining > 0) await sleep(remaining)
    return result
  } catch (error) {
    if (options?.skipMinOnError !== true) {
      const remaining = Math.max(0, minMs - (Date.now() - startedAt))
      if (remaining > 0) await sleep(remaining)
    }
    throw error
  }
}
